import AppsCrumb from '../components/AppsCrumb';
import MicroAppCrumb from '../components/MicroAppCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const appsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/apps',
    breadcrumbs: [
        {
            component: AppsCrumb,
        },
    ],
    children: [
        {
            path: ':appSlug',
            breadcrumbs: [
                {
                    component: MicroAppCrumb,
                    props: { isCurrentPage: true },
                },
            ],
            children: [
                {
                    path: '*',
                    breadcrumbs: [],
                },
            ],
        },
    ],
};
